export enum ModalMode {
  notice = "notice",
  default = "default",
}
